import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APP_SETTINGS, AnalyticsService, AuthService, DialogService, SpinnerService, ToastConfigService, UtilityService } from '@services';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { BMWListData, MINIListData, MOTORRADListData, NoiseCatalogParamsRefDataResponse, ROLLSROYCEListData, ResultStatus } from 'src/app/core/models';
import { CmsNavbarService } from '../../cms-navbar/cms-navbar.service';
import { ModelMapService } from '../../model-map/model-map.service';
import { NoiseCatalogService } from '../../noise-catalog/noise-catalog.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { VideosService } from '../../videos/videos.service';
import { AdminService } from '../admin.service';
import { NgIf, NgFor } from '@angular/common';
import { SelectRequiredValidatorDirective } from '../../../shared/directives/select-required-validator.directive';

declare var $: any;
@Component({
    selector: 'app-add-bulletin-for-noise-catalog',
    templateUrl: './add-bulletin-for-noise-catalog.component.html',
    styleUrls: ['./add-bulletin-for-noise-catalog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, NgIf, SelectRequiredValidatorDirective, NgFor, NgMultiSelectDropDownModule]
})
export class AddBulletinForNoiseCatalogComponent implements OnInit, OnDestroy {
  public bulletinType = '';
  public actionType = '';
  private subscriptions: ISubscription[] = [];
  public makeList;
  public inputMake;
  public inputDate: string;
  public selDate;
  public tkrCode = '';
  public isTakataRecall = false;
  public documentNumber = '';
  public bulletinNumber = '';
  public textareaContent = '';
  public relatedSIBs: string[] = [];
  public setDateFlag: boolean = false;

  public reactivateOrDeactivate: any;
  public isDocActive = false;
  public makeNameForApi: string;
  //  public listMakeName: ParamListItem[];

  public inputSeries = '';
  public inputModel = '';
  public inputEngine = '';

  public inputSproadicPermanent: any;
  public inputArea = '';
  public inputComponent = '';
  public inputDrivingCondition = '';
  public inputWeatherCondition = '';
  public inputKindOfNoise = '';

  public inputChannel: any;
  public channelsList = [];
  public sproadicPermanentList = [];

  public seriesList: any[];
  public seriesFilterList: any[];


  public areaList: string[];
  public areaFilterList: string[];
  public componentList: any[];
  public componentFilterList: any[];
  public drivingConditionList: any[];
  public drivingConditionFilterList: any[];
  public weatherConditionList: any[];
  public weatherConditionFilterList: any[];
  public kindOfNoiseList: any[];
  public kindOfNoiseFilterList: any[];
  public noiseCatalogParamsRefDataResponse: NoiseCatalogParamsRefDataResponse;

  public documentNumbersList: any[];
  public obdCategories: any[];
  public docId: number;

  private userEmail: string;

  public errorMessage = '';
  public errorMessageSIB = '';
  public showAllFields: boolean = false;

  public uploadedFileName = 'No File Selected';
  public vimeoID = '';
  public uploadedFile = null;

  public pageTitle: string;

  public allObdData: any[];
  public documentOBDTitle;

  public newUploadFlag: boolean = false;
  public showAllOptionsOBD: boolean = false;
  public showAllOptionsTool: boolean = false;

  public isMotorradAdmin: boolean = false;
  public isRollsRoyceAdmin: boolean = false;
  public isAdmin: boolean = false;
  public isMotorrad: boolean = false;
  public isRollsRoyce: boolean = false;
  public showTakata: boolean = false;
  dropdownESeriesList = [];
  dropdownAreaList = [];
  dropdownComponentList = [];
  dropdownDrivingConditionList = [];
  dropdownKindOfNoiseList = [];
  dropdownWeatherConditionList = [];
  selectedItems = [];
  BMW?: BMWListData;
  MINI?: MINIListData;
  MOTORRAD?: MOTORRADListData;
  ROLLSROYCE?: ROLLSROYCEListData;
  prevMake?: string;
  currentMake?: string;
  makeSelected?: string;
  //dropdownSettings = {};
  // public sproadicPermanentList = [];
  mouseoverLogin;
  dropdownSettingsSeries: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'seriesName',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    // idField: 'value',
    // textField: 'viewValue',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    itemsShowLimit: 0,
    limitSelection: -1,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false,

  };

  constructor(
    private cmsNavbarService: CmsNavbarService,
    private toastService: ToastConfigService,
    private adminService: AdminService,
    private modelMapService: ModelMapService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private changeDetectorRef: ChangeDetectorRef,
    private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private videoService: VideosService,
    private noiseCatalogService: NoiseCatalogService,
    private dialogService: DialogService,
    private analyticsService: AnalyticsService
    //private cmsNavbarService: CmsNavbarService,

  ) {
  }

  getPageTitle(): string {

    //this.pageTitle = (this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1) + " " + this.bulletinType.charAt(0).toUpperCase() + this.bulletinType.slice(1));
    this.pageTitle = (this.actionType.charAt(0).toUpperCase() + this.actionType.slice(1) + " " + "Noise Catalog");
    return this.pageTitle;
  }

  public onDropDownClose(item: any): void {
  }

  ngOnInit() {
    this.errorMessageSIB = '';
    this.inputSproadicPermanent = "undefined";
    this.inputChannel = "undefined";

    this.makeSelected = "BMW";
    this.prevMake = "undefined";
    // this.listMakeName = [{ value: 1, viewValue: 'BMW' },
    // { value: 2, viewValue: 'MINI' }, { value: 3, viewValue: 'MOTORRAD' }];


    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    // $(function () {
    //   $('[data-toggle="tooltip"]').tooltip()
    // })

    if (APP_SETTINGS.isMotorradAdmin === 'true') {
      this.isMotorradAdmin = true;
      this.makeSelected = "MOTORRAD";
    }

    if (APP_SETTINGS.isRollsRoyceAdmin === 'true') {
      this.isRollsRoyceAdmin = true;
      this.makeSelected = "ROLLSROYCE";
    }

    if (APP_SETTINGS.isAdmin === 'true') {
      this.isAdmin = true;
      //this.makeSelected = "MOTORRAD";
    }

    if (APP_SETTINGS.isMOTORRAD === 'true') {
      this.isMotorrad = true;
      this.makeSelected = "MOTORRAD";
    }

    if (APP_SETTINGS.isRollsRoyce === 'true') {
      this.isRollsRoyce = true;
      this.makeSelected = "ROLLSROYCE";
    }
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });

    this.pageTitle = '';

    this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
      this.userEmail = userData['email'];
    });

    // this.userEmail = 'Chad.Pinson@partner.bmwgroup.com';
    this.documentNumbersList = [];
    this.seriesList = [];

    this.resetFields();
    this.getPageTitle();
    this.bulletinType = this.route.snapshot.paramMap.get('bulletinType');
    this.actionType = this.route.snapshot.paramMap.get('actionType');

    this.areaList = [];
    this.componentList = [];
    this.componentFilterList = [];
    this.drivingConditionList = [];
    this.weatherConditionList = [];
    this.kindOfNoiseList = [];
    this.subscriptions.push(this.cmsNavbarService.getAllMakeList().subscribe(data => {
      if (this.isMotorradAdmin === true) {
        this.makeList = data.filter(make => (make['makeName'] === 'MOTORRAD'));
      }
      else if (this.isRollsRoyceAdmin === true) {
        this.makeList = data.filter(make => (make['makeName'] === 'ROLLSROYCE'));
      } else {
        this.makeList = data.filter(make => (make['makeName'] === 'BMW' || make['makeName'] === 'MINI' || make['makeName'] === 'MOTORRAD' || make['makeName'] === 'ROLLSROYCE'));
      }
    }));

    this.subscriptions.push(this.cmsNavbarService.getMainGroupsList().subscribe(data => {
      this.channelsList = data;
    }));

    this.subscriptions.push(this.modelMapService.getAllSeries().subscribe(data => {
      this.seriesList = data;
      this.dropdownESeriesList = this.seriesList;
    }));

    this.subscriptions.push(this.noiseCatalogService.findAllNoiseCatalogParamsRefData().subscribe(
      (data: NoiseCatalogParamsRefDataResponse) => {
        this.noiseCatalogParamsRefDataResponse = data;
      },
      (err: ResultStatus) => {
        console.error('Error when calling findAllNoiseCatalogParamsRefData', err);
      },
      () => this.populateNoiseParamList()
    ));

    this.setRandomDocNumber();

  }

  populateNoiseParamList() {
    if (this.noiseCatalogParamsRefDataResponse != null && this.noiseCatalogParamsRefDataResponse.status.statusCode === 'SUCCESS') {
      this.BMW = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.BMW;
      this.MINI = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.MINI;
      this.MOTORRAD = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.MOTORRAD;
      this.ROLLSROYCE = this.noiseCatalogParamsRefDataResponse.noiseCatalogDataParams.ROLLSROYCE;
      //this.prevMake = "BMW";
      //this.makeSelected = "BMW";
      //  if (this.makeSelected === 'BMW') {
      this.populateNoiseParamListByMake(this.makeSelected);
      this.inputSproadicPermanent = this.sproadicPermanentList.find(sproadicPermanent => sproadicPermanent === 'Sporadic');
      //  }

    }
  }


  onMakeSelectionChanged(event) {

    if (this.makeSelected != "undefined" && this.prevMake != event) {
      if (this.dialogService.confirm('Changing the Make will reset the form entries, all entries will be lost. \n Do you want to continue? ')['value'] === true) {
        this.makeSelected = event;
        this.prevMake = event;
        this.changeMaingroupList(this.makeSelected);
        this.populateNoiseParamListByMake(this.makeSelected);
      }
      else {
        this.makeSelected = this.prevMake;
      }
    }
    if (this.makeSelected == "undefined" && event != "undefined") {
      this.makeSelected = event;
      this.prevMake = event;
      this.changeMaingroupList(this.makeSelected);
      this.populateNoiseParamListByMake(this.makeSelected);
    }

    return this.prevMake;
  }
  changeMaingroupList(makeNameCurrent) {
    this.subscriptions.push(this.cmsNavbarService.getMainGroupsListbyMakeName(makeNameCurrent).subscribe(data => {
      this.channelsList = data;
    }));
  }

  populateNoiseParamListByMake(makeNameCurrent) {

    this.resetFields();
    if (makeNameCurrent === 'BMW') {
      this.inputMake = 'BMW';
      this.areaList = this.BMW.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.BMW.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.BMW.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.BMW.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.BMW.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.BMW.sporadicOrPermanent;
    }
    else if (makeNameCurrent === 'MINI') {
      this.inputMake = 'MINI';
      this.areaList = this.MINI.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.MINI.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.MINI.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.MINI.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.MINI.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.MINI.sporadicOrPermanent;
    }
    else if (makeNameCurrent === 'MOTORRAD') {
      this.inputMake = 'MOTORRAD';
      this.areaList = this.MOTORRAD.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.MOTORRAD.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.MOTORRAD.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.MOTORRAD.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.MOTORRAD.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.MOTORRAD.sporadicOrPermanent;
    }
    else if (makeNameCurrent === 'ROLLSROYCE') {
      this.inputMake = 'ROLLSROYCE';
      this.areaList = this.ROLLSROYCE.area;
      this.dropdownAreaList = this.areaList;
      this.componentList = this.ROLLSROYCE.component;
      this.dropdownComponentList = this.componentList;
      this.drivingConditionList = this.ROLLSROYCE.driveConditions;
      this.dropdownDrivingConditionList = this.drivingConditionList;
      this.weatherConditionList = this.ROLLSROYCE.weatherConditions;
      this.dropdownWeatherConditionList = this.weatherConditionList;
      this.kindOfNoiseList = this.ROLLSROYCE.kindOfNoise;
      this.dropdownKindOfNoiseList = this.kindOfNoiseList;
      this.sproadicPermanentList = this.ROLLSROYCE.sporadicOrPermanent;
    }

  }

  getAllVideoNumbers(makeName) {
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.adminService.getAllVideoNumbers(makeName).subscribe(data => {
      this.spinnerService.hide('bmwSpinner');
      this.documentNumbersList = data;
    }));
  }

  resetFields() {
    this.inputMake = null;
    this.seriesFilterList = [];
    this.relatedSIBs = [];
    this.uploadedFile = this.inputDate = '';
    this.uploadedFileName = 'No File Selected';
    this.vimeoID = '';
    this.bulletinNumber = this.documentNumber = this.textareaContent = this.tkrCode = '';
    this.isTakataRecall = false;
    this.newUploadFlag = false;
    this.documentNumber = null;
    this.makeNameForApi = undefined;

    this.areaList = [];
    this.dropdownAreaList = [];
    this.areaFilterList = [];
    this.componentList = [];
    this.dropdownComponentList = [];
    this.componentFilterList = [];

    this.drivingConditionList = [];
    this.dropdownDrivingConditionList = [];
    this.drivingConditionFilterList = [];

    this.weatherConditionList = [];
    this.dropdownWeatherConditionList = [];
    this.weatherConditionFilterList = [];

    this.kindOfNoiseList = [];
    this.dropdownKindOfNoiseList = [];
    this.kindOfNoiseFilterList = [];

    this.sproadicPermanentList = [];
    this.inputSproadicPermanent = "undefined";
    this.inputChannel = "undefined";


  }

  addToSelection(listType: string, listItem: string | object) {
    listItem = listItem !== null && typeof listItem === 'object' ? listItem['engineName'] : listItem;
    if (listItem) {
      switch (listType) {
        case 'sib':
          this.bulletinNumber = '';
          this.addNewBulletin(this.makeSelected, listItem);
          break;
      }
    }
  }

  addNewBulletin(makeSelected, bulletinNumber) {
    this.errorMessageSIB = '';
    if (bulletinNumber) {
      const bulletinId = bulletinNumber.replace(/\s+/g, "");
      this.adminService.findBulletinByNumberMake(bulletinId, makeSelected).subscribe(
        bulletinData => {
          this.relatedSIBs.push(bulletinNumber);
        },
        error => {
          console.error('Error when finding Bulletin By NumberMake', error);
          this.errorMessageSIB = 'Please enter valid active SIB.';
          //this.errorMessage = error.error.message;
        });
    }
  }


  removeFromSelection(listType: string, listItem: string) {
    switch (listType) {
      case 'sib':
        this.relatedSIBs = this.relatedSIBs.filter(item => item !== listItem);
        break;
    }
  }


  removeFromNoiseSelection(listType: any, listItem: any) {
    switch (listType) {

      case 'series':
        this.seriesFilterList = this.seriesFilterList.filter(item => item !== listItem.seriesName);
        break;
      case 'area':
        this.areaFilterList = this.areaFilterList.filter(item => item !== listItem);
        break;
      case 'component':
        this.componentFilterList = this.componentFilterList.filter(item => item !== listItem);
        break;
      case 'drivingCondition':
        this.drivingConditionFilterList = this.drivingConditionFilterList.filter(item => item !== listItem);
        break;
      case 'weatherCondition':
        this.weatherConditionFilterList = this.weatherConditionFilterList.filter(item => item !== listItem);
        break;
      case 'kindOfNoise':
        this.kindOfNoiseFilterList = this.kindOfNoiseFilterList.filter(item => item !== listItem);
        break;
    }
  }


  public addToNoiseSelection(listType: string, listItem: any): void {
    // FIXME this code is being used, but it does nothing, it shoule be removed in the future
  }

  fileUpload(fileObj) {
    if (fileObj && fileObj.target.files.length > 0) {
      const file = fileObj.target.files[0];
      const isFileValid = this.utilityService.fileValidator(file.name);
      if (!isFileValid) {
        this.errorMessage = 'File type not supported';
        this.uploadedFile = null;
        this.uploadedFileName = '';
      } else {
        this.errorMessage = '';
        this.uploadedFile = file;
        this.uploadedFileName = file.name;
        this.newUploadFlag = true;
      }
    }
  }

  onSubmit(form: NgForm) {
    if (form.valid) {
      this.submit();
    }

  }

  submit() {
    // this.inputDate = (this.inputDate) ? this.inputDate['formatted'] : this.setDefaultDate();
    if (this.inputDate == null) {
      this.inputDate = this.setDefaultDate();
    }
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
    if (this.actionType === 'add') {
      this.spinnerService.show("bmwSpinner");
      if (this.bulletinType === 'noise catalog') {

        //const selectedSeries = this.seriesList.filter(series => this.seriesFilterList.includes(series['seriesName']));
        const selectedSeries = filterSeriesArray(this.seriesList, this.seriesFilterList);
        const selectedMake = this.makeList.find(make => make['makeName'] === this.inputMake);
        const noiseObject = {
          "noiseCatalogDisplayNumber": this.documentNumber,
          "noiseCatalogTitle": this.textareaContent,
          "bulletinDisplayNumber": this.relatedSIBs,
          "make": selectedMake,
          "mainGroup": this.inputChannel,
          "releaseDate": this.inputDate,
          "createdTs": this.setDefaultDate(),
          "updatedTs": this.setDefaultDate(),
          "series": selectedSeries,
          "noiseCatalogAreas": this.areaFilterList,
          "noiseCatalogComponents": this.componentFilterList,
          "noiseDrivingConditions": this.drivingConditionFilterList,
          "noiseWeatherConditions": this.weatherConditionFilterList,
          "noiseNoiseTypes": this.kindOfNoiseFilterList,
          "sporadicOrPermanent": this.inputSproadicPermanent,
          "noiseCatalogVimeoId": this.vimeoID,
          "likes": 0,
          "dislikes": 0,
          "views": 0,
        };

        this.subscriptions.push(this.adminService.createNewNoiseCatalog(noiseObject).subscribe(value => {
          this.errorMessage = '';
          this.errorMessageSIB = '';
          if (value) {
            this.spinnerService.hide("bmwSpinner");
            this.resetFields();
            this.toastService.popToast('Noise Catalog added');
            this.errorMessage = '';
            this.errorMessageSIB = '';
            this.inputSeries = '';
            this.inputArea = '';
            this.inputComponent = '';
            this.inputDrivingCondition = '';
            this.inputWeatherCondition = '';
            this.inputKindOfNoise = '';
            //this.inputChannel = null;
            //this.inputSproadicPermanent = null;
            this.inputSproadicPermanent = "undefined";
            this.inputChannel = "undefined";
            this.makeSelected = "undefined";
            this.prevMake = 'undefined';
            this.router.navigate(['/noise-catalog/home']);
          }
        },
          error => {
            this.spinnerService.hide("bmwSpinner");
            console.error('Error Creating New Noise Catalog', error);
            //this.errorMessage = error.error.message;
            if (error.error.status !== null && error.error.status.statusCode === 'FAILURE') {
              this.errorMessage = error.error.status.errorDetails;
            }
          }));
      }
    }
    //Analytic Call
    this.analyticCallNoiseCatalogAdded();
  }

  analyticCallNoiseCatalogAdded() {
    let userID = this.authService.getUserName();
    this.analyticsService.trackNewContentAdded(userID, "Noise Catalog", this.makeSelected, this.documentNumber, 'added');
  }

  setRandomDocNumber() {
    if (this.bulletinType == "obd") {
      this.documentNumber = "OD" + Math.floor(100000 + Math.random() * 900000);
      return this.documentNumber;
    } else {
      return '';
    }
  }

  onAddRelatedSIB(bulletinNumber) {
    this.relatedSIBs.push(bulletinNumber);
  }

  formatBulletinNumber(event: any, sibOrVideo: string) {

    if (event.key == "ArrowLeft" || event.key == "ArrowRight" || event.keyCode == 8 || event.keyCode == 65 || event.keyCode == 67 || event.keyCode == 17) { return };
    let tempInput;
    let split = 2;
    let chunk = [];
    // tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");

    if (sibOrVideo === 'sib') {
      tempInput = this.bulletinNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.bulletinNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.bulletinNumber = tempInput.slice(0, 8);

    }
    else if (sibOrVideo === 'noise catalog') {
      tempInput = this.documentNumber;
      tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");
      for (let i = 0; i < this.documentNumber.length; i += split) {
        chunk.push(tempInput.substr(i, split));
      }
      tempInput = chunk.join(' ').trim();
      this.documentNumber = tempInput.slice(0, 8);

    }
  }

  setDefaultDate(): string {
    let d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

  private handleBrandChange() {
    let make: string;

    if (typeof this.inputMake === 'object') {
      make = this.inputMake['makeName'];
    } else {
      make = this.inputMake;
    }

    if (make === 'BMW' || make === 'MINI') {
      this.showTakata = true;
    } else if (make === 'MOTORRAD' || make === 'ROLLSROYCE') {
      this.showTakata = false;
    } else {
      this.showTakata = true;
    }
  }
}

function filterSeriesArray(array, filter) {
  var myArrayFiltered = [];
  for (var i = 0; i < array.length; i++) {
    for (var j = 0; j < filter.length; j++) {
      if (array[i].id === filter[j].id && array[i].seriesName === filter[j].seriesName) {
        myArrayFiltered.push(array[i]);
      }
    }
  }
  return myArrayFiltered;
}